module.exports = __webpack_public_path__ + "img/i-minus.7bcc6c68.svg";